/** */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { setPageTitle } from 'store/actions/header';
import { Spacer } from 'app/member/layouts/generic';
import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import { OpportunitiesPage } from './opportunities';
import { RevenueReportPage } from './revenue-report';

const nav_items = [
  { title: 'Revenue Report', path: '/revops/revenue' },
  { title: 'Opportunities', path: '/revops/opportunities' }
];

const RevOpsModule = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'RevOps', path: '.' }]));
  }, [dispatch]);

  return (
    <PageContentWrapper>
      <SlidingNav nav_items={nav_items} />
      <Spacer multiple={4} />
      <Routes>
        <Route path="/revenue" element={<RevenueReportPage />} />
        <Route path="/opportunities" element={<OpportunitiesPage />} />
        <Route path="/*" element={<Navigate to="/revops/revenue" replace />} />
      </Routes>
    </PageContentWrapper>
  );
};

export default RevOpsModule;
